export default __webpack_public_path__ + "static/media/icon-alarm-white-20.29b86a09.svg";